import { render, staticRenderFns } from "./PlayingContainer.vue?vue&type=template&id=5ed6c9d9&scoped=true&"
import script from "./PlayingContainer.vue?vue&type=script&lang=js&"
export * from "./PlayingContainer.vue?vue&type=script&lang=js&"
import style0 from "./PlayingContainer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PlayingContainer.vue?vue&type=style&index=1&id=5ed6c9d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed6c9d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
